var React = require('react');

function ArrowLeftIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M11.89,2.53C11.59,2.19,11.19,2,10.77,2c-0.42,0-0.82,0.19-1.12,0.53l-7.18,8.19\n                c-0.15,0.17-0.27,0.37-0.34,0.59C2.04,11.53,2,11.76,2,12c0,0.24,0.04,0.47,0.12,0.69c0.08,0.22,0.2,0.42,0.35,0.59l7.18,8.19\n                c0.62,0.7,1.62,0.7,2.24,0c0.62-0.71,0.62-1.85,0-2.56l-4.48-5.11h13.16C21.45,13.81,22,13,22,12s-0.55-1.81-1.43-1.81H7.41\n                l4.48-5.11C12.51,4.38,12.5,3.23,11.89,2.53z"}));
}

ArrowLeftIcon.defaultProps = {"data-dmid":"dm-arrow-left","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = ArrowLeftIcon;

ArrowLeftIcon.default = ArrowLeftIcon;
